import './FilterPanel.css';const filterPanel = "_filterPanel_vol6d_1";
const filterPanel__parameters = "_filterPanel__parameters_vol6d_19";
const styles = {
  filterPanel,
  filterPanel__parameters
};
export {
  styles as default,
  filterPanel,
  filterPanel__parameters
};
